import { canonicalSportForFilter, isIndoorActivity } from "./sportNormalization";

const SPORT_LABELS = {
  cycling: "Cycling",
  running: "Running",
  walking: "Walking",
  hiking: "Hiking",
  swimming: "Swimming",
  rowing: "Rowing",
};

const sportFallbackTitle = (activity) => {
  const sport = canonicalSportForFilter(activity);
  const label = SPORT_LABELS[sport];
  if (!label) return "Activity";
  if (isIndoorActivity(activity)) {
    if (sport === "cycling") return "Indoor Cycling Activity";
    if (sport === "running") return "Indoor Running Activity";
  }
  return `${label} Activity`;
};

/**
 * Display name for an activity.
 *
 * The backend is the source of truth for the canonical name: it resolves user
 * edits, source (e.g. Strava) titles, embedded file metadata and filename in
 * priority order. The frontend only falls back to a neutral sport label if the
 * stored name is entirely missing/blank. It never invents "Morning Ride" /
 * "Evening Run" style names from the recorded time of day.
 */
export const deriveActivityName = (activity) => {
  if (!activity) return "Activity";
  const stored = typeof activity.name === "string" ? activity.name.trim() : "";
  if (stored) return stored;
  return sportFallbackTitle(activity);
};
